export default "__VITE_ASSET__D6I$hZgl__"